var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacetoface(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    d: "M120.2,150l-19.7-49.9c0,0-2-20.7-3.7-28.4C88.6,36,48.7,3.8,5.8,3.8C4.6,3.8,4,3.8,2,3.9V253h46v-28h15.2 c20.7,0,37.8-17.2,37.8-37.9V161h12.3c4.3,0,7.7-3.6,7.7-7.9C121,151.9,120.7,150.7,120.2,150z M77.4,119c-5.8,0-10.5-4.8-10.5-10.5 c0-5.7,4.8-10.5,10.5-10.5s10.5,4.8,10.5,10.5C87.9,114.2,83.1,119,77.4,119z M135,153.1c0,4.3,3.5,7.9,7.7,7.9H155v26.1 c0,20.7,17.1,37.9,37.8,37.9H208v28h46V3.9c-2,0-2.6-0.1-3.8-0.1c-42.9,0-82.7,32.2-91,67.9c-1.7,7.7-3.7,28.4-3.7,28.4L135.8,150 C135.3,150.7,135,151.9,135,153.1z M168.1,108.5c0-5.7,4.8-10.5,10.5-10.5s10.5,4.8,10.5,10.5c0,5.7-4.7,10.5-10.5,10.5 C172.9,119,168.1,114.2,168.1,108.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacetoface);
export default __webpack_public_path__ + "static/media/facetoface.170821ed14f45935968d29a8e0437ac7.svg";
export { ForwardRef as ReactComponent };